import React from 'react';
import { Box, Typography } from '@mui/material';

const TeamV2SettingsContainer = () => {
    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333' }}>
                Settings
            </Typography>
        </Box>
    );
};

export default TeamV2SettingsContainer;

